import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearActiveRow, setActiveRow } from '../../../../services/grid/gridActions';

export const useActiveRow = ({ bookingNo }: { bookingNo: number }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveRow(bookingNo));
    return () => {
      dispatch(clearActiveRow());
    };
  }, [dispatch, bookingNo]);
};
